import { render, staticRenderFns } from "./25.vue?vue&type=template&id=5c0d1f3a&scoped=true&"
var script = {}
import style0 from "./25.vue?vue&type=style&index=0&id=5c0d1f3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0d1f3a",
  null
  
)

export default component.exports